import { useI18n } from "@/context/I18nContext";

export const YT_ON_HOLD = true;

export const YtBuildBadge = ({ testid = "yt-build-badge", className = "" }) => {
  const { t } = useI18n();
  return (
    <span data-testid={testid} title={t("pub.build_hint")}
      className={`inline-flex items-center gap-1 rounded-full border border-[#ffb020]/40 bg-[#ffb020]/10 px-2 py-0.5 text-[10px] font-semibold text-[#ffcc66] whitespace-nowrap ${className}`}>
      🚧 {t("pub.build")}
    </span>
  );
};
